import { Lightbulb } from 'lucide-react';

const FUNNEL_STAGES = ['GA4 Events', 'Form Fills', 'Phone Calls', 'Reservations', 'Revenue'];

export function FunnelTeaser() {
  return (
    <div className="ed-card border-dashed p-4">
      <div className="flex gap-3">
        <Lightbulb className="h-5 w-5 text-[var(--ed-t3)] flex-shrink-0 mt-0.5" />
        <div>
          <div className="text-sm font-semibold text-[var(--ed-t1)] mb-1">
            Coming Soon — Full Funnel Intelligence
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Connect Google Ads → Website Analytics → Reservations → Revenue.
            See exactly which campaigns drive the most profitable guests, not just clicks.
          </p>
          <div className="flex flex-wrap gap-4 mt-3">
            {FUNNEL_STAGES.map((stage) => (
              <div key={stage} className="flex items-center gap-1.5 text-[0.6rem] text-muted-foreground/50">
                <span className="text-[var(--ed-t4)]">●</span>
                {stage}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
